import React from 'react'
import styles from './MainArea.module.scss'

interface MainAreaProps {
  children: React.ReactNode
  className?: never
}

export const MainArea: React.FC<MainAreaProps> = ({ children }) => (
  <main className={styles.main}>{children}</main>
)
